import React from "react";
import heroRightImg from "../../assets/heroRightImg.png";
import GetStartedBtn from "../commonComponents/GetStartedBtn";
import styled from 'styled-components'

const HeroSection = () => {
  return (
    <Box>
      <div className="heroLeft">
        <h1 className="mainTitle">
          Welcome to the <span className="colored">AI-Driven</span> MCQ Practice Platform.
        </h1>
        <p>
          Your AI-Powered Study Companion!
        </p>
        <GetStartedBtn />
      </div>
      <div className="heroRight">
        <img src={heroRightImg} />
      </div>
    </Box>
  );
};

export default HeroSection;

const Box = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    margin-left: 5vw;
    margin-right: 5vw;
    min-height: calc(100vh - 70px);
    margin-top: 70px;
    gap: 5vw;


  .heroLeft {
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: center;
    align-items: flex-start;
  
   .mainTitle {
    font-size: 5.25rem;
    margin-bottom: 0.5rem;
  }

  .colored {
    color: var(--orange);
  }

}
  
  
  .heroLeft p {
    font-size: 2.6rem;
    font-weight: 400;
  }
  
  .heroRight {
    display: flex;
    width: 100%;
    justify-content: center;
  }
  
  .heroRight img {
    width: 100%;
  }
  
  
  
  @media (max-width: 580px) {
    .heroRight {
      display: none;
    }
  
    .heroSection {
      grid-template-columns: 1fr;
    }
  
    .heroLeft {
      margin-left: 2vw;
      margin-right: 2vw;
    }
  
    .heroLeft h1 {
      font-size: 5rem;
    }
  
    .heroLeft p {
      font-size: 2rem;
      font-weight: 400;
    }
  }


`